import React from "react";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

const SwitchList = ({ items, labelPlacement, value, change }) => {
  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup value={value} onChange={change}>
          {items.map(item => (
            <FormControlLabel
              key={item.id}
              value={item.id}
              control={<Radio color="primary" />}
              label={item.label}
              labelPlacement={labelPlacement}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default SwitchList;
